const DEFAULT_COMPARATOR = 'Geen vergelijking';

export default {
  DEFAULT_COMPARATOR,
  COMPARATORS: {
    default: [
      DEFAULT_COMPARATOR, 'rendement', 'ouderbijdrage', 'schoolgidsen', 'schoolplannen', 'artikelen',
      'bijzonderheden', 'onderwijsconcept', 'video', 'inspectieoordeel', 'tevredenheid',
    ],
    po: [
      DEFAULT_COMPARATOR, 'rendement', 'ouderbijdrage', 'schoolgidsen', 'schoolplannen', 'inspectieoordeel',
    ],
    vo: [
      DEFAULT_COMPARATOR, 'artikelen', 'bijzonderheden', 'onderwijsconcept', 'ouderbijdrage',
      'schoolgidsen', 'schoolplannen', 'video', 'inspectieoordeel', 'tevredenheid',
      'vmbo_profielen',
    ],
  },

  // TODO: fix examencijfers
};
